
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "width": "17px",
    "height": "17px",
    "viewBox": "0 0 17 17",
    "enable-background": "new 0 0 17 17",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "id": "审核",
        "transform": "translate(-1050 -664)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "审核-2",
            "transform": "translate(1019 633)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_5",
                "fill": "#FFFFFF",
                "d": "M38.669,40.755l-1.577-1.568l-0.653,0.653l2.156,2.165l4.993-3.995l-0.579-0.728\r\n\t\t\tL38.669,40.755z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_6",
                "fill": "#FFFFFF",
                "d": "M39.5,32c-4.142,0-7.5,3.358-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5\r\n\t\t\tC47,35.358,43.643,32,39.5,32L39.5,32z M39.5,46c-3.59,0-6.5-2.91-6.5-6.5s2.91-6.5,6.5-6.5s6.5,2.91,6.5,6.5S43.09,46,39.5,46z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  